// PartBPage6/index.jsx - Part B Page 6 (Student Editor - View Only Rubric)
import React from 'react';
import { useActivityContext } from '../index';

const PartBPage6 = () => {
  const { activity } = useActivityContext();
  const rubric = activity?.part_b?.page_6?.rubric || {
    awareness_level: null,
    sensitivity_level: null,
    creativity_level: null
  };

  const levels = [
    { key: 'beginner', label: 'Beginner', score: 5 },
    { key: 'proficient', label: 'Proficient', score: 10 },
    { key: 'advanced', label: 'Advanced', score: 15 }
  ];

  const renderRubricRow = (ability, selectedLevel, bgColor) => {
    return (
      <tr>
        <td style={{
          backgroundColor: bgColor,
          padding: '50px 12px',
          fontWeight: 'bold',
          fontSize: '12px',
          border: '2px solid #F4824C',
          verticalAlign: 'middle',
          textAlign: 'left',
          color: '#666'
        }}>
          {ability}
        </td>
        {levels.map(level => (
          <td key={level.key} style={{
            backgroundColor: bgColor,
            padding: '40px 20px',
            border: '2px solid #F4824C',
            textAlign: 'center',
            verticalAlign: 'bottom'
          }}>
            <div style={{
              width: '20px',
              height: '20px',
              border: '2px solid #999',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              backgroundColor: '#f9f9f9'
            }}>
              {selectedLevel === level.key && '✓'}
            </div>
          </td>
        ))}
      </tr>
    );
  };

  return (
    <div style={{
        width: '100%',
        maxWidth: '1400px',
        minHeight: '80vh',
        margin: '0 auto',
        padding: '40px',
        backgroundColor: 'white',
        fontFamily: "'Poppins', Arial, sans-serif",
        position: 'relative',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
      }}>
        {/* Decorative Corners */}
        

        {/* Header */}
        <div style={{
          backgroundColor: '#F4824C',
          color: 'white',
          fontSize: '14px',
          fontWeight: 'bold',
          padding: '10px',
          textAlign: 'center',
          marginBottom: '20px'
        }}>
          Stage 3
        </div>

        {/* Info Note */}
        <div style={{
          backgroundColor: '#E3F2FD',
          borderLeft: '4px solid #2196F3',
          padding: '10px 15px',
          marginBottom: '16px',
          fontSize: '12px',
          color: '#1565C0'
        }}>
          📘 This rubric is filled by your teacher to assess your performance. You can view but cannot edit this assessment.
        </div>

        {/* Instructions */}
        <div style={{
          fontSize: '14px',
          marginBottom: '16px',
          lineHeight: '1.5',
          textAlign: 'justify'
        }}>
          Based on the contents of the final output of the project, write a rubric for each ability and achievement level. Tick (✓) as per the learner's performance.
        </div>

        {/* Rubric Table */}
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginBottom: '20px'
        }}>
          <thead>
            <tr>
              <th style={{
                backgroundColor: '#FFE5D5',
                border: '2px solid #F4824C',
                padding: '0',
                width: '20%'
              }}></th>
              {levels.map(level => (
                <th key={level.key} style={{
                  backgroundColor: '#FFE5D5',
                  border: '2px solid #F4824C',
                  padding: '10px',
                  textAlign: 'center',
                  width: '26.67%'
                }}>
                  <div style={{ fontWeight: 'bold', fontSize: '12px', marginBottom: '4px' }}>
                    {level.label}
                  </div>
                  <div style={{
                    width: '28px',
                    height: '28px',
                    border: '2px solid #F4824C',
                    borderRadius: '50%',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    fontSize: '12px',
                    backgroundColor: 'white'
                  }}>
                    {level.score}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {renderRubricRow('Awareness', rubric.awareness_level, '#FFE5D5')}
            {renderRubricRow('Sensitivity', rubric.sensitivity_level, 'white')}
            {renderRubricRow('Creativity', rubric.creativity_level, '#FFE5D5')}
          </tbody>
        </table>

        {/* Bottom Corners */}
        
        
      </div>

  );
};

export default PartBPage6;
